import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "exam-type"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  class: "exam-go"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "exam-go",
  style: {
    "color": "#666"
  }
};
const _hoisted_7 = {
  class: "exam-empty"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  return _openBlock(), _createElementBlock(_Fragment, null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.list[$props.type], (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "exam-item",
      key: 'exam1' + index
    }, [_createElementVNode("p", _hoisted_1, [_createElementVNode("span", {
      class: _normalizeClass(item.skill)
    }, null, 2), _createElementVNode("span", null, _toDisplayString(item.examName ? item.examName : $setup.store.state.skill[item.skill]), 1)]), _createElementVNode("div", null, [_createVNode(_component_el_button, {
      style: {
        "background": "none",
        "border": "none",
        "padding": "0",
        "margin-right": "3px"
      },
      icon: $setup.Clock
    }, null, 8, ["icon"]), _cache[1] || (_cache[1] = _createElementVNode("span", null, "考试时间", -1)), _createElementVNode("span", null, [_createTextVNode(_toDisplayString($setup.timestamp2Date(item.beginDate)) + " 至", 1), _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)), _createTextVNode(_toDisplayString($setup.timestamp2Date(item.endDate)), 1)])]), 77 % item.status == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_el_button, {
      style: {
        "background": "none",
        "border": "none",
        "padding": "0",
        "margin-right": "3px"
      },
      icon: $setup.Timer
    }, null, 8, ["icon"]), _cache[2] || (_cache[2] = _createElementVNode("span", null, "作答时长", -1)), _createElementVNode("span", null, _toDisplayString($setup.getDurationM(item)) + "分钟", 1)])) : _createCommentVNode("", true), _createElementVNode("div", null, [_createVNode(_component_el_button, {
      style: {
        "background": "none",
        "border": "none",
        "padding": "0",
        "margin-right": "3px"
      },
      icon: $setup.User
    }, null, 8, ["icon"]), _cache[3] || (_cache[3] = _createElementVNode("span", null, "发布人", -1)), _createElementVNode("span", null, _toDisplayString(item.publisherName), 1)]), _createElementVNode("div", null, [_createVNode(_component_el_button, {
      style: {
        "background": "none",
        "border": "none",
        "padding": "0",
        "margin-right": "3px"
      },
      icon: $setup.Bell
    }, null, 8, ["icon"]), _cache[4] || (_cache[4] = _createElementVNode("span", null, "截止时间", -1)), _createElementVNode("span", {
      class: _normalizeClass($setup.endTimeDistance(item.endDate) ? 'tip-text' : '')
    }, _toDisplayString($setup.timestamp2Date(item.endDate)), 3)]), _createVNode(_component_el_tooltip, {
      class: "box-item",
      content: '开始时间:' + $setup.timestamp2Date(item.beginDate)
    }, {
      default: _withCtx(() => [_withDirectives(_createElementVNode("p", _hoisted_3, " 未开始 ", 512), [[_vShow, $props.type == 0 && item.beginDate - $setup.time > 0]])]),
      _: 2
    }, 1032, ["content"]), _withDirectives(_createElementVNode("p", {
      class: "exam-go",
      onClick: $event => $setup.goExam(item)
    }, " 进入测试 ", 8, _hoisted_4), [[_vShow, $props.type == 0 && $setup.time - item.beginDate >= 0]]), _withDirectives(_createElementVNode("p", {
      class: "exam-go",
      onClick: $event => $setup.goReport(item, item.skill)
    }, " 查看报告 ", 8, _hoisted_5), [[_vShow, $props.type == 1 && !(item.examType == 19 || item.examType == 3)]]), _withDirectives(_createElementVNode("p", _hoisted_6, " 已完成 ", 512), [[_vShow, $props.type == 1 && (item.examType == 19 || item.examType == 3)]])]);
  }), 128)), (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, index => {
    return _createElementVNode("div", {
      class: "exam-item exam-item-block",
      key: 'exam2' + index
    });
  }), 64)), _withDirectives(_createElementVNode("div", _hoisted_7, "暂无考试", 512), [[_vShow, $props.list[$props.type].length == 0]])], 64);
}